import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import {
  ModalWrapper,
  DivFooter,
  StyleButtonClose,
  ButtonSave,
  ButtonTutorial,
  DivRowFooter,
  DivColFooter,
  TableCustom,
} from '../../styled'
import AppResource from 'general/constants/AppResource'
import { Empty } from 'antd'
import {
  downloadZip,
  embedPDF,
  extractFields,
  getMimeType,
} from 'general/utils/Utils'
import { useEffect, useState } from 'react'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import ToastHelper from 'general/helpers/ToastHelper'
function FindDeductionDocuments(
  {
    openModalFind,
    changeOpenModalFind,
    dataSource,
    panningDataSource,
    changePaniningFind,
  },
  props,
) {
  const { t } = useTranslation()
  const [dataFile, setDataFile] = useState([])
  const [inforHSSD, setInforHSSD] = useState({ disable: false })
  const columns = [
    {
      title: t('taxDeduction.stt'),
      dataIndex: 'stt',
      width: 80,
      className: 'center-header',
      render: (text, record, index) => (
        <div className="center-cell">
          {(panningDataSource.page - 1) * panningDataSource.limit + (index + 1)}
        </div>
      ),
    },
    {
      title: t('taxDeduction.listDocument'),
      dataIndex: 'nameDeductionDocuments',
      width: 600,
      className: 'center-header',
      render: (text, record, index) => (
        <div className="left-cell">
          {record.nameDeductionDocuments}
          {record.base64 && (
            <img
              className="view"
              src={AppResource.taxDeduction.keenTaxDuctionView}
              onClick={() => embedPDF(record.base64)}
            />
          )}
        </div>
      ),
    },
  ]

  useEffect(() => {
    setDataFile(extractFields(dataSource, ['nameFile', 'base64'], 'base64'))
  }, [dataSource])

  const getFileCacheAddFile = async (code) => {
    let result = await reportApi.downloadFilePublic({ code })
    setInforHSSD({ disable: false })
    if (result?.fileData?.type === 'Buffer') {
      const byteArray = new Uint8Array(result?.fileData?.data)
      const nameFile = result?.nameFile
      const blob = new Blob([byteArray], {
        type: getMimeType(nameFile),
      })
      saveAs(blob, nameFile)
    } else {
      ToastHelper.showError('Invalid buffer data')
    }
  }

  return (
    <>
      <ModalWrapper
        title={t('taxDeduction.registrationFile')}
        open={openModalFind}
        onCancel={() => changeOpenModalFind(false)}
        width={750}
        footer={
          <DivFooter>
            <DivRowFooter className="row">
              <DivColFooter className="col-6">
                <ButtonTutorial
                  disabled={inforHSSD?.disable}
                  onClick={async () => {
                    // window.open(
                    //   '/hoa-don-dau-ra/khau-tru-thue-thu-nhap-ca-nhan/huongdan',
                    //   '_blank',
                    // )
                    setInforHSSD({ disable: true })
                    await getFileCacheAddFile('HDSD_TNCN')
                  }}
                >
                  {t('taxDeduction.viewTutorial')}
                </ButtonTutorial>
              </DivColFooter>
              <DivColFooter className="col-6" justifyContent={'right'}>
                <StyleButtonClose
                  onClick={() => {
                    changeOpenModalFind(false)
                  }}
                >
                  {t('taxDeduction.closeModal')}
                </StyleButtonClose>
                <ButtonSave
                  type="primary"
                  disabled={dataFile.length == 0}
                  onClick={() => {
                    downloadZip(dataFile)
                  }}
                >
                  {t('taxDeduction.download')}
                </ButtonSave>
              </DivColFooter>
            </DivRowFooter>
          </DivFooter>
        }
      >
        <TableCustom
          dataSource={dataSource ?? []}
          columns={columns}
          locale={{
            emptyText: <Empty description={t('taxDeduction.noData')} />,
          }}
          pagination={
            panningDataSource.totalPages > 1
              ? {
                  current: panningDataSource.page,
                  pageSize: panningDataSource.limit,
                  total: panningDataSource.totalItems,
                }
              : false
          }
          onChange={(pagination) => {
            changePaniningFind(pagination.current, pagination.pageSize)
          }}
        />
      </ModalWrapper>
    </>
  )
}
export default FindDeductionDocuments
